import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "HIGHLANDER",
    price: "999",
    offerprice:"799",
    categoryName: "Shirt",
    image:"https://bit.ly/34D1GuL",
    rating:"4.2",
    qty:"1",
  },
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "HIGHLANDER",
    price: "1024",
    offerprice:"879",
    categoryName: "Shirt",
    image:"https://bit.ly/3BhlRdr",
    rating:"3.8",
    qty:"1",
  },
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "HIGHLANDER",
    price: "1999",
    offerprice:"1599",
    categoryName: "Shirt",
    image:"https://bit.ly/3oLqTKd",
    rating:"4.1",
    qty:"1",
  },
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "HIGHLANDER",
    price: "3479",
    offerprice:"2699",
    categoryName: "Shirt",
    image:"https://bit.ly/3Bf1ZYF",
    rating:"4.5",
    qty:"1",
  },
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "ROADSTER",
    price: "6999",
    offerprice:"4799",
    categoryName: "Shirt",
    image:"https://bit.ly/3rKrI84",
    rating:"5",
    qty:"1",
  },
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "ROADSTER",
    price: "2999",
    offerprice:"2199",
    categoryName: "Shirt",
    image:"https://bit.ly/3HL6ht9",
    rating:"2.9",
    qty:"1",
  },
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "ROADSTER",
    price: "1859",
    offerprice:"1599",
    categoryName: "Shirt",
    image:"https://bit.ly/34O2blo",
    rating:"3.5",
    qty:"1",
  },
  {
    _id: uuid(),
    title: "Slim fit casual Shirt",
    author: "ROADSTER",
    price: "3999",
    offerprice:"2199",
    categoryName: "Shirt",
    image:"https://bit.ly/34RHBRg",
    rating:"4.7",
    qty:"1",
  },
// category 2
{
  _id: uuid(),
  title: "Men Adi Running Shoes",
  author: "ADIDAS",
  price: "1999",
  offerprice:"1749",
  categoryName: "Shoes",
  image:"https://bit.ly/3GFSGSF",
  rating:"1.7",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men Adi Running Shoes",
  author: "ADIDAS",
  price: "4999",
  offerprice:"3499",
  categoryName: "Shoes",
  image:"https://bit.ly/3HOYPxc",
  rating:"2.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men Adi Running Shoes",
  author: "ADIDAS",
  price: "5999",
  offerprice:"4619",
  categoryName: "Shoes",
  image:"https://bit.ly/3BhVAM5",
  rating:"4.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men Adi Running Shoes",
  author: "ADIDAS",
  price: "2999",
  offerprice:"1999",
  categoryName: "Shoes",
  image:"https://bit.ly/3LtAyiq",
  rating:"3.1",
  qty:"1",
},
{
  _id: uuid(),
  title: "Strom Runner",
  author: "REEBOK",
  price: "3999",
  offerprice:"2779",
  categoryName: "Shoes",
  image:"https://bit.ly/3HMAbgt",
  rating:"2.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Strom Runner",
  author: "REEBOK",
  price: "3199",
  offerprice:"2649",
  categoryName: "Shoes",
  image:"https://bit.ly/3HZavNG",
  rating:"3.6",
  qty:"1",
},
{
  _id: uuid(),
  title: "Strom Runner",
  author: "REEBOK",
  price: "5489",
  offerprice:"4549",
  categoryName: "Shoes",
  image:"https://bit.ly/3rUuAzv",
  rating:"2.9",
  qty:"1",
},
{
  _id: uuid(),
  title: "Strom Runner",
  author: "REEBOK",
  price: "3999",
  offerprice:"2749",
  categoryName: "Shoes",
  image:"https://bit.ly/3oLzU5Z",
  rating:"1.6",
  qty:"1",
},

// Sarees
{
  _id: uuid(),
  title: "Striped Saree",
  author: "MITERA",
  price: "8999",
  offerprice:"2599",
  categoryName: "Saree",
  image:"https://bit.ly/3GGsQ0B",
  rating:"1.9",
  qty:"1",
},
{
  _id: uuid(),
  title: "Striped Saree",
  author: "MITERA",
  price: "7199",
  offerprice:"4299",
  categoryName: "Saree",
  image:"https://bit.ly/36aArrT",
  rating:"4.9",
  qty:"1",
},
{
  _id: uuid(),
  title: "Striped Saree",
  author: "MITERA",
  price: "6199",
  offerprice:"4379",
  categoryName: "Saree",
  image:"https://bit.ly/3JsSqIv",
  rating:"3.4",
  qty:"1",
},
{
  _id: uuid(),
  title: "Striped Saree",
  author: "MITERA",
  price: "5999",
  offerprice:"2599",
  categoryName: "Saree",
  image:"https://bit.ly/3rNuHwF",
  rating:"4.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Tie and Dye Saree",
  author: "KALAKARI INDIA",
  price: "6199",
  offerprice:"3114",
  categoryName: "Saree",
  image:"https://bit.ly/3t0w36H",
  rating:"3.6",
  qty:"1",
},
{
  _id: uuid(),
  title: "Tie and Dye Saree",
  author: "KALAKARI INDIA",
  price: "4599",
  offerprice:"2714",
  categoryName: "Saree",
  image:"https://bit.ly/3oRwYVs",
  rating:"2.6",
  qty:"1",
},
{
  _id: uuid(),
  title: "Tie and Dye Saree",
  author: "KALAKARI INDIA",
  price: "4599",
  offerprice:"3214",
  categoryName: "Saree",
  image:"https://bit.ly/3rOvlty",
  rating:"5",
  qty:"1",
},
{
  _id: uuid(),
  title: "Tie and Dye Saree",
  author: "KALAKARI INDIA",
  price: "6599",
  offerprice:"3599",
  categoryName: "Saree",
  image:"https://bit.ly/36gTi4z",
  rating:"4.2",
  qty:"1",
},

// Activewear
{
  _id: uuid(),
  title: "Men's Gyn T-Shirts",
  author: "HRX BY HRITIK",
  price: "1699",
  offerprice:"999",
  categoryName: "Activewear",
  image:"https://bit.ly/3HSMgB2",
  rating:"1.7",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Gyn T-Shirts",
  author: "HRX BY HRITIK",
  price: "2599",
  offerprice:"1999",
  categoryName: "Activewear",
  image:"https://bit.ly/3oRiHIq",
  rating:"3.4",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Gyn T-Shirts",
  author: "HRX BY HRITIK",
  price: "4779",
  offerprice:"3299",
  categoryName: "Activewear",
  image:"https://bit.ly/3oUhkJ3",
  rating:"4.2",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Gyn T-Shirts",
  author: "HRX BY HRITIK",
  price: "2899",
  offerprice:"2299",
  categoryName: "Activewear",
  image:"https://bit.ly/3sIGLOL",
  rating:"2.1",
  qty:"1",
},
{
  _id: uuid(),
  title: "Rapid Dry Trackpants",
  author: "HRX BY HRITIK",
  price: "5999",
  offerprice:"4759",
  categoryName: "Activewear",
  image:"https://bit.ly/3rRe1nK",
  rating:"4.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Rapid Dry Trackpants",
  author: "HRX BY HRITIK",
  price: "6999",
  offerprice:"2759",
  categoryName: "Activewear",
  image:"https://bit.ly/3sK7cUl",
  rating:"5",
  qty:"1",
},
{
  _id: uuid(),
  title: "Rapid Dry Trackpants",
  author: "HRX BY HRITIK",
  price: "5699",
  offerprice:"3259",
  categoryName: "Activewear",
  image:"https://bit.ly/3rTkQ8q",
  rating:"2.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Rapid Dry Trackpants",
  author: "HRX BY HRITIK",
  price: "2999",
  offerprice:"1899",
  categoryName: "Activewear",
  image:"https://bit.ly/3GSFXMq",
  rating:"4.7",
  qty:"1",
},

// Jeans
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "2999",
  offerprice:"1499",
  categoryName: "Jeans",
  image:"https://bit.ly/3LDFIs7",
  rating:"1.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "3999",
  offerprice:"2199",
  categoryName: "Jeans",
  image:"https://bit.ly/3HW8cuS",
  rating:"2.8",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "1999",
  offerprice:"999",
  categoryName: "Jeans",
  image:"https://bit.ly/3Jvsj3t",
  rating:"5",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "3499",
  offerprice:"2299",
  categoryName: "Jeans",
  image:"https://bit.ly/3Lx2rWV",
  rating:"2.2",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "4599",
  offerprice:"3159",
  categoryName: "Jeans",
  image:"https://bit.ly/3BmeKk9",
  rating:"3.7",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "5499",
  offerprice:"4299",
  categoryName: "Jeans",
  image:"https://bit.ly/3uQp96f",
  rating:"4.9",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "1599",
  offerprice:"959",
  categoryName: "Jeans",
  image:"https://bit.ly/3BmLYjr",
  rating:"2.1",
  qty:"1",
},
{
  _id: uuid(),
  title: "Men's Slim Fit Jeans",
  author: "HIGHLANDER JEANS",
  price: "1899",
  offerprice:"1289",
  categoryName: "Jeans",
  image:"https://bit.ly/3HTFGdj",
  rating:"4.3",
  qty:"1",
},

];
